<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
        <el-form-item label="AccessKeyId：" prop="accessKeyId">
          <el-input style="width: 424px;" v-model="ruleForm.accessKeyId" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="AccessKeySecret：" prop="accessKeySecret">
          <el-input style="width: 424px;" v-model="ruleForm.accessKeySecret" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="短信签名：" prop="signName">
          <el-input style="width: 424px;" v-model="ruleForm.signName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="验证码模板：" prop="templateCode">
          <el-input style="width: 424px;" v-model="ruleForm.templateCode" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="用户类型：" prop="userType">
          <el-radio-group v-model="ruleForm.userType">
            <el-radio :label="1">单个/多个</el-radio>
            <el-radio :label="2">用户等级</el-radio>
          </el-radio-group>
          <div v-if="ruleForm.userType == 1">
            <div style="width: 100%;height: 32px;"></div>
            <div class="mt-transfer-box">
              <!-- <div class="mt-transfer-search">
                <el-form :model="searchForm" ref="searchForm" label-width="0px" class="demo-ruleForm">
                  <el-form-item prop="name">
                    <el-input style="width:196px;" v-model="searchForm.name" placeholder="请输入用户昵称/手机号"></el-input>
                    <el-button type="medium" style="margin-left: 0px;" @click="searchTopBtn">查询</el-button>
                  </el-form-item>
                </el-form>
              </div> -->
              <el-transfer
                ref="transfer"
                :titles="titles"
                filterable
                filter-placeholder="请输入用户昵称/手机号"
                :filter-method="filterMethod"
                v-model="ruleForm.businessIdStr"
                :props="{
                  key: 'value',
                  label: 'label'
                }"
                :data="infoList">
              </el-transfer>
            </div>
          </div>
        </el-form-item>
        <el-form-item v-if="ruleForm.userType == 2" label="会员等级：" prop="templateCode">
          <el-select v-model="memberLevelId" placeholder="请选择等级类型" style="width: 424px;">
            <el-option
              v-for="item in memberLevelList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="medium" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { fetchMarketSmsConfigDetail, saveMarketSmsLog, queryAllUser, queryAllMemberLevel } from '@/api/sms'
export default {
  name: 'SmsConfig',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      infoListSelected:[],
      fullscreenLoading: false,
      ruleForm: {
        accessKeyId:'',
        accessKeySecret:'',
        signName:'',
        templateCode:'',
        userType:1,
        businessIdStr:[]
      },
      rules: {
        accessKeyId: [
          { required: true, message: '请输入AccessKeyId', trigger: 'blur' }
        ],
        accessKeySecret: [
          { required: true, message: '请输入AccessKeySecret', trigger: 'blur' }
        ],
        signName: [
          { required: true, message: '请输入短信签名', trigger: 'blur' }
        ],
        templateCode: [
          { required: true, message: '请输入短信模板', trigger: 'blur' }
        ]
      },
      memberLevelId:'',
      memberLevelList:[],
      titles:['用户列表','待发送用户'],
      filterMethod(query, item) {
        return item.label.indexOf(query) > -1;
      }
    }
  },
  mounted () {
    // this.setupScrollListener();
    var that = this;
    fetchMarketSmsConfigDetail({}).then((res) => {
        if (res.errorCode === '0000') {
          var data = res.data;
          if(data.userType == null){
            data.userType = 1;
          }
          if(data.templateCode == 2){
            that.memberLevelId = data.businessIdStr[0];
          }
          that.ruleForm = data;
        }
    });
    that.getInfoList();
    that.memberLevelFun();
  },
  methods: {
    // 等级数据
    memberLevelFun(){
      var that = this;
      queryAllMemberLevel({}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.memberLevelList = data
        }
        if (res.errorCode === '4002') {
          that.memberLevelList = []
        }
      })
    },
    // setupScrollListener() {
    //   const transferEl = this.$refs.transfer.$el.querySelector('.el-transfer-panel__list'); // 获取滚动区域元素
    //   console.log(transferEl,'transferEl');
    //   transferEl.addEventListener('scroll', this.handleScroll);
    // },
    // handleScroll() {
    //   const transferEl = this.$refs.transfer.$el.querySelector('.el-transfer-panel__list'); // 获取滚动区域元素
    //   const isScrolledToBottom = transferEl.scrollHeight - transferEl.scrollTop <= transferEl.clientHeight;
    //   if (isScrolledToBottom) {
    //     console.log('已滚动到底部');
    //     this.currentPage += 1
    //     this.getInfoList();
    //     // 在这里执行你的操作，例如加载更多数据等
    //   }
    // },
    // 搜索用户列表
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据-用户列表
    getInfoList () {
      let that = this
      let page = that.currentPage
      queryAllUser({ pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 保存操作
    saveBtn () {
      let that = this
      let memberLevelId = that.memberLevelId;
      let ruleForm = that.ruleForm
      if(ruleForm.userType == 2){
        ruleForm.businessIdStr = [memberLevelId];
      }
      if(ruleForm.accessKeyId === ''){
        this.$message.error('请输入AccessKeyId')
        return false
      }
      if(ruleForm.accessKeySecret == ''){
        this.$message.error('请输入AccessKeySecret')
        return false
      }
      if(ruleForm.signName == ''){
        this.$message.error('请输入短信签名')
        return false
      }
      if(ruleForm.userType == 1 && ruleForm.businessIdStr.length <= 0){
        this.$message.error('请选择用户')
        return false
      }
      if(ruleForm.userType == 2 && ruleForm.businessIdStr.length <= 0){
        this.$message.error('请选择等级类型')
        return false
      }
      that.fullscreenLoading = true
      saveMarketSmsLog(ruleForm).then((res) => {
        that.fullscreenLoading = false
        if (res.errorCode === '0000') {
          this.$message({
            message: res.msg,
            type: 'success',
            onClose () {
              that.$router.go(0)
            }
          })
        }
        if (res.errorCode === '1001') {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
  .el-transfer-panel{
    width: 300px;
    height:422px;
  }
  .el-transfer-panel__body.is-with-footer{
    padding-top:60px;
  }
  .el-transfer-panel__list.is-filterable {
    height: 280px; /* 穿梭框列表高度 */
  }
  .el-transfer-panel__list{height: 280px;}
</style>



// WEBPACK FOOTER //
// src/pages/market/sms/Config.vue